import { handleResponse, Headers } from '../_helpers';

export const TimelineService = {
  newTimeline,
  updateTimeline,
  deleteTimeline,
};

function newTimeline(params) {
  //{ worldId, chronicleID, title }
  const request = {
    method: 'POST',
    headers: Headers.set(),
    body: JSON.stringify(params),
  };

  return fetch(`${process.env.API_URL}/api/v1/timeline/new`, request)
    .then(handleResponse)
    .then((timeline) => {
      return timeline;
    });
}

function updateTimeline(timelineData) {
  const id = timelineData._id;
  const request = {
    method: 'POST',
    headers: Headers.set(),
    body: JSON.stringify(timelineData),
  };

  return fetch(`${process.env.API_URL}/api/v1/timeline/${id}`, request)
    .then(handleResponse)
    .then((timeline) => {
      return timeline;
    });
}

function deleteTimeline(timelineID) {
  const request = {
    method: 'DELETE',
    headers: Headers.set(),
  };

  return fetch(`${process.env.API_URL}/api/v1/timeline/${timelineID}`, request)
    .then(handleResponse)
    .then(() => {
      return true;
    });
}
